<template>
  <div>
    <div v-if="loading">Loading</div>
    <template v-else>
      <eden-page-header
        :title="'Customers'"
        :subtitle="customerName"
        :section="'Wallet'"
      >
        <template slot="actions">
          <div class="is-flex is-flex-wrap align-center">
            <customer-actions
              section="wallet"
              :customer="customer"
              @fetch="getCustomer"
              @update="fetchAllItems"
            >
              <template slot="actions-trigger">
                <el-button type="plain">
                  Actions <i class="eden-icon-arrow-down"></i>
                </el-button>
              </template>
            </customer-actions>

            <div class="page--head-actions">
              <el-button
                type="primary"
                v-if="allowAccessFor(['superadmin', 'gardener_pro', 'gardener'])"
                @click="openFundWallet"
              >
                Fund wallet
              </el-button>
            </div>
          </div>
        </template>
      </eden-page-header>
      <customers-corporate-wallet-banner :wallet="walletSummary"/>
      <div class="mt-4">
        <el-tabs v-model="tab" @tab-click="updateRouteQuery">
          <el-tab-pane label="Wallet Activity" name="activity">
            <wallet-activity ref="walletActivity"/>
          </el-tab-pane>
        </el-tabs>
      </div>
      <fund-wallet-option-dialog
        :show.sync="showFundWalletDialog"
        @update-activity="fetchAllItems"
      />
    </template>
  </div>
</template>

<script>
import CustomersCorporateWalletBanner from "@/components/Customers/Corporate/Wallet/CustomersCorporateWalletBanner.vue";
import WalletActivity from "@/components/Customers/Corporate/Wallet/WalletActivity.vue";
import FundWalletOptionDialog from "@/components/Customers/Corporate/Wallet/FundWallet/FundWalletOptionsDialog.vue";
import corporate from "@/requests/customers/corporate";
import wallet from "@/requests/customers/corporate/wallet";
import CustomerActions from "@/components/Customers/Corporate/Actions/CustomerActions";

export default {
  name: "CustomerCorporateWallet",
  components: {
    CustomersCorporateWalletBanner,
    CustomerActions,
    WalletActivity,
    FundWalletOptionDialog,
  },
  data() {
    return {
      loading: false,
      customer: {},
      wallet: {},
      walletSummary: {},
      tab: "activity",
      showFundWalletDialog: false,
    };
  },
  computed: {
    customerName() {
      return this.customer.company_name
        ? this.formatName(this.customer.company_name)
        : "";
    },
    customerId() {
      return this.$route.params.id;
    },
  },
  created() {
    this.getWalletSummary();
    let { t } = this.$route.query;
    this.tab = t ? t : "activity";
  },
  methods: {
    getCustomer() {
      this.loading = true;
      corporate
        .get(this.customerId)
        .then((response) => {
          this.customer = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    fetchAllItems() {
      this.$refs.walletActivity.getCustomerWallet({ period: 'thisweek' });
      this.getWalletSummary();
    },
    getWalletSummary() {
      this.loading = true;
      wallet
        .summary(this.customerId)
        .then((response) => {
          this.walletSummary = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    updateRouteQuery(tab) {
      const { t } = this.$route.query;

      if (t === this.tab) {
        return false;
      }
      this.$router.push({
        name: "customers.corporate.wallet",
        params: { id: this.customerId },
        query: { t: tab.name },
      });
    },
    openFundWallet() {
      this.showFundWalletDialog = true;
    },
  },
};
</script>



